<template>
  <div class="audit-chart mb-2">
    <div class="half">
      <strong class="d-block font-size-18 font-weight-semi-bold mb-3">Geogrid</strong>
      <div class="d-flex flex-wrap row-gap-6">
        <dl class="w-100 w-sm-50 m-0">
          <dt class="font-weight-semi-bold">Created</dt>
          <dd class="font-weight-semi-bold mb-0">{{ geogrid.createdAt }}</dd>
        </dl>
        <dl class="w-100 w-sm-50 m-0">
          <dt class="font-weight-semi-bold">AGR</dt>
          <dd class="font-weight-semi-bold mb-0">{{ geogrid.agr }}</dd>
        </dl>
        <dl class="w-100 w-sm-50 m-0">
          <dt class="font-weight-semi-bold">Google region</dt>
          <dd class="font-weight-semi-bold mb-0">{{ geogrid.attrs.localLanguageEnabled ? 'Local' : 'Global' }}</dd>
        </dl>
        <dl class="w-100 w-sm-50 m-0">
          <dt class="font-weight-semi-bold">ATGR</dt>
          <dd class="font-weight-semi-bold mb-0">{{ geogrid.atgr }}</dd>
        </dl>
        <dl class="w-100 w-sm-50 m-0">
          <dt class="font-weight-semi-bold">Grid</dt>
          <dd class="font-weight-semi-bold mb-0">{{ geogrid.grid }}</dd>
        </dl>
        <dl class="w-100 w-sm-50 m-0">
          <dt class="font-weight-semi-bold">SoLV</dt>
          <dd class="font-weight-semi-bold mb-0">{{ geogrid.solv }}</dd>
        </dl>
      </div>
    </div>
    <div class="half geogrid-map" id="geogrid-map" />
  </div>
</template>

<script>
import { ensureGoogleMap } from 'common/map_helpers'
import { createMarkers, showGridMarkers, fitBounds } from 'vue_widgets/geogrids/map/helpers'

export default {
  props: {
    sectionData: { type: Object, required: true }
  },
  data: () => ({
    geogrid: null,
    googleMapApiKey: null
  }),
  created() {
    this.geogrid = this.sectionData.geogrid
    this.googleMapApiKey = this.sectionData.googleMapApiKey
  },
  mounted() {
    ensureGoogleMap({ googleMapApiKey: this.googleMapApiKey }, () => {
      this.map = new google.maps.Map(document.getElementById('geogrid-map'), {
        disableDefaultUI: true,
        center: {
          lat: parseFloat(this.geogrid.attrs.gridCenterLat),
          lng: parseFloat(this.geogrid.attrs.gridCenterLng)
        }
      })

      this.mapMarkers = createMarkers()

      showGridMarkers(
        this.geogrid.attrs,
        this.geogrid.gridRanks,
        [],
        [],
        this.mapMarkers,
        this.map,
        new google.maps.Size(30, 30)
      )

      fitBounds(
        {
          mapMarkers: this.mapMarkers,
          map: this.map
        },
        this.geogrid.attrs.gridSize * this.geogrid.attrs.gridSize - 1,
        {
          top: 15, bottom: 15, left: 15, right: 15
        }
      )
    })
  }
}
</script>
